import styled from 'styled-components';
import { theme } from '../../styles/theme';

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  z-index: ${theme.zIndex.character};
`;

const Character = styled.div<{ $imageUrl: string }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  background-image: url(${props => props.$imageUrl});
  background-size: contain;
  background-position: right bottom;
  background-repeat: no-repeat;
  transition: transform ${theme.transitions.slow};

  &:hover {
    transform: scale(1.02);
  }
`;

interface CharacterSectionProps {
  imageUrl?: string;
}

export function CharacterSection({ imageUrl = '/character.png' }: CharacterSectionProps) {
  return (
    <Container>
      <Character $imageUrl={imageUrl} />
    </Container>
  );
} 